import ConfigParameter, { gettext } from "../ConfigParameter";

export default class Language extends ConfigParameter {

    constructor() {
        super('language', 'object-select', gettext('Language'), 'mainConfig', 'en_GB', null, [{value: 'en_GB', label: 'English'}, {value: 'pl_PL', label: 'Polski'}], null, null, gettext('Language change will be visible only on generated page.'));
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Language.js